import simbApi from ".";
import { ITEM_MERGE, ITEM_MERGE_PREVIEW, ITEM_MERGE_STATUS } from "../../data/constants/endpoints";
import type {
  MergeCandidatesResult,
  MergeColumnChoices,
  MergeNameFrom,
  MergePreviewResult,
  MergeRunStatus,
} from "../../components/MergeItem/mergeItem.types";

const authHeaders = (accessToken: string) => ({ headers: { Authorization: `Bearer ${accessToken}` } });

/** Which items of one picker page can be merged with the current item. */
export const getMergeCandidates = async (
  accessToken: string,
  args: { currentItemId: string; currentBoardId: string; candidateBoardId: string; candidateItemIds: string[] },
): Promise<MergeCandidatesResult> => {
  const response = await simbApi.post<{ data: MergeCandidatesResult }>(
    ITEM_MERGE_PREVIEW,
    args,
    authHeaders(accessToken),
  );
  return response.data.data;
};

/** Everything the review step shows, or why the pair cannot be merged. */
export const getMergePreview = async (
  accessToken: string,
  args: { currentItemId: string; otherItemId: string },
): Promise<MergePreviewResult> => {
  const response = await simbApi.post<{ data: MergePreviewResult }>(
    ITEM_MERGE_PREVIEW,
    args,
    authHeaders(accessToken),
  );
  return response.data.data;
};

export const startMerge = async (
  accessToken: string,
  args: {
    currentItemId: string;
    currentBoardId: string;
    otherItemId: string;
    otherBoardId: string;
    nameFrom: MergeNameFrom;
    columnChoices: MergeColumnChoices;
  },
): Promise<{ requestId: string }> => {
  const response = await simbApi.post<{ requestId: string }>(ITEM_MERGE, args, authHeaders(accessToken));
  return response.data;
};

export const getMergeStatus = async (accessToken: string, requestId: string): Promise<MergeRunStatus> => {
  const response = await simbApi.post<MergeRunStatus>(ITEM_MERGE_STATUS, { requestId }, authHeaders(accessToken));
  return response.data;
};
